import { useAuth } from "../../context/AuthContext";
import MyVisitsPage from "./MyVisitsPage";
import TeamVisitsPage from "./TeamVisitsPage";
import AllVisitsPage from "./AllVisitsPage";

export default function VisitsRouter() {
  const { user } = useAuth();
  const role = user?.role;
  if (role === "sales_officer") return <MyVisitsPage />;
  if (role === "assistant_manager" || role === "admin_manager") return <TeamVisitsPage />;
  return <AllVisitsPage />;
}
